import React,{
    useEffect,
    useState
} from "react";

import axios from "axios";

import "./NextLevelCard.css";

import{

    Lock,

    ArrowUpCircle

} from "lucide-react";

const NextLevelCard=()=>{

    const email=
    localStorage.getItem(
        "user_email"
    );

    const[nextLevel,setNextLevel]=
    useState(2);

    const[currentLevel,setCurrentLevel]=
    useState(1);

    const[remaining,setRemaining]=
    useState(0);

    const useLockedBar =
        currentLevel < nextLevel;

    useEffect(()=>{

        loadJourney();

    },[]);

    const loadJourney=async()=>{

        try{

            const res=
            await axios.get(

                `/api/ignite/journey/${email}`

            );

            const objectives=

            res.data.levelObjectives;

            setCurrentLevel(

                objectives.currentLevel

            );

            setRemaining(

                objectives.total-

                objectives.completed

            );

            setNextLevel(

                Math.min(

                    objectives.currentLevel+1,

                    4

                )

            );

        }

        catch(err){

            console.error(err);

        }

    };

    const levelNames={

        2:"CONTENDER",

        3:"PERFORMER",

        4:"ELITE"

    };

    return(

        <div className="next-level-card">

            <div className="next-header">

                <div>

                    <h3>

                        Next Level

                    </h3>

                    <p>

                        Your upcoming milestone.

                    </p>

                </div>

                <Lock
                    size={28}
                />

            </div>

            <div className="next-level-number">

                Level {nextLevel}

            </div>

            <div className="next-level-name">

                <ArrowUpCircle
                    size={18}
                />

                {levelNames[nextLevel]}

            </div>

            <div className="next-progress">

                <div className="next-progress-bar">

                    {

                        useLockedBar ?

                        <div className="next-progress-locked"/>

                        :

                        <div

                            className="next-progress-fill"

                            style={{

                                width:"100%"

                            }}

                        />

                    }

                </div>

            </div>

            <div className="next-footer">

                <span>

                    Remaining Tasks

                </span>

                <strong>

                    {remaining}

                </strong>

            </div>

        </div>

    );

};

export default NextLevelCard;